import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

const FaviconHandler = () => {
    const location = useLocation();

    useEffect(() => {
        const changeFavicon = (faviconPath) => {
            console.log('Changing favicon to:', faviconPath);
            
            // Remove all existing favicon links
            const existingLinks = document.querySelectorAll("link[rel*='icon']");
            existingLinks.forEach(link => {
                if (link.parentNode) {
                    link.parentNode.removeChild(link);
                }
            });

            // Create new favicon link with timestamp to force refresh
            const timestamp = new Date().getTime();
            const newLink = document.createElement('link');
            newLink.type = 'image/png';
            newLink.rel = 'shortcut icon';
            newLink.href = `${faviconPath}?v=${timestamp}`;
            
            // Also add as icon rel for better compatibility
            const iconLink = document.createElement('link');
            iconLink.type = 'image/png';
            iconLink.rel = 'icon';
            iconLink.href = `${faviconPath}?v=${timestamp}`;

            // Add to head
            const head = document.getElementsByTagName('head')[0];
            head.appendChild(newLink);
            head.appendChild(iconLink);
            
            console.log('Favicon updated successfully');
        };

        // Add delay to ensure DOM is ready
        const updateFavicon = () => {
            // Determine which favicon to use based on route
            if (location.pathname.startsWith('/translator')) {
                changeFavicon('/favicon_translator.png');
                document.title = 'Quick Translator - Intelligent Multilingual Translation App';
                console.log('Set translator favicon and title');
            } else if (location.pathname.startsWith('/tomo')) {
                changeFavicon('/favicon_tomo.png');
                document.title = 'Tomo - Smart Task Management';
                console.log('Set Tomo favicon and title');
            } else if (location.pathname.startsWith('/pdf')) {
                changeFavicon('/favicon.png');
                document.title = 'PDF Viewer - Modern Document Reading Experience';
                console.log('Set PDF viewer favicon and title');
            } else {
                // Default for homepage
                changeFavicon('/favicon.png');
                document.title = 'Prasadji Games Studio - Mobile App Solutions';
                console.log('Set default favicon and title');
            }
        };
        
        // Use timeout to ensure DOM is fully loaded
        const timer = setTimeout(updateFavicon, 100);
        
        // Cleanup function
        return () => clearTimeout(timer);
    }, [location.pathname]);

    return null; // This component doesn't render anything
};

export default FaviconHandler; 